import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import HeaderBrandArea from './HeaderBrandArea';
import HeaderNotificationArea from './HeaderNotificationArea';
import HeaderNavigationArea from './HeaderNavigationArea';

import './Header.css';

import { observer, inject } from 'mobx-react';

@withRouter
@inject('translationsStore')
@observer
class Header extends Component {
  render() {
    return (
      <div className="Header">
        <HeaderBrandArea />
        <HeaderNavigationArea />
        <HeaderNotificationArea />
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/App/Header/Header.js